import * as yup from 'yup';
import { basicPaymentRule, primaryPhoneRule, b2cPaymentRule, } from '../../../utils/validation-rules/payment-rule';
import { isB2BUser } from '../../../utils/user';
import { isProd } from '../../../utils/environments';
import { ORANGE_PAY_URL_PROD, ORANGE_PAY_URL_STG, } from '../../../constants/links';
export const orangePayConsts = {
    url: isProd() ? ORANGE_PAY_URL_PROD : ORANGE_PAY_URL_STG,
    clientId: 'HDCOM_MYACCOUNT',
    storeNumber: isProd() ? '8119' : '9064',
    storeZipCode: '30339',
    amount: 1,
    countryCode: 'US',
    languageCode: 'en-US',
    orderNumber: '12345',
    billingAddress: {},
    transactionOptions: {
        tokenizeOnly: true,
    },
    cardBrokerEnabled: true,
    saqAEnabled: true,
    saveCard: false,
};
export const cssStyles = '.flex-container {padding: 0 1px 0 0 !important;}' +
    '.form-input--error .form-input__field {' +
    "   background-image: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAx" +
    'NiAxNiIgZmlsbD0iI0M2NEM0QyIgZm9jdXNhYmxlPSJmYWxzZSIgYXJpYS1oaWRkZW49InRy' +
    'dWUiPjxwYXRoIGQ9Ik0xNS4zMzQgMC42NjZIMC42NjZ2MTQuNjY2aDE0LjY2NnpNOC43MzQg' +
    'NC4wODh2NS4zNzhINy4yNjdWNC4wODl6bTAgNy4wODlhMC43MzQgMC43MzQgMCAxIDEgLTEu' +
    "NDY2IDAgMC43MzQgMC43MzQgMCAwIDEgMS40NjYgMCIvPjwvc3ZnPg==');" +
    '   background-color: initial;' +
    '   background-repeat: no-repeat;' +
    '   background-size: 16px 16px;' +
    '   border: 1px solid rgb(198 76 76 / 1) !important; ' +
    '   height: 44px !important;' +
    '}' +
    '.label { font-family: helvetica-neue-55-roman, ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; font-size: 1.6rem; color: rgb(33 33 32 / 1) !important; }' +
    '.drop-down__title {' +
    '   border: 1px solid #999; height: 44px !important;' +
    '   border-radius: 0.2rem;' +
    '   border-color: rgb(122 121 120 / 1);' +
    '} ' +
    '.flex-container .form-input__field {' +
    '    height: 44px;' +
    '    border-bottom: 1px solid #999;' +
    '    border-radius: 0.2rem;' +
    '    border-color: rgb(122 121 120 / 1);' +
    '}' +
    '.form-input--error .form-input-error__message, .expiration-date .drop-down-error__message {' +
    '   color: #C64C4C !important;' +
    '   line-height: 1;' +
    '   font-size: 1.2rem;' +
    '   font-family: helvetica-neue-55-roman, ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"' +
    '}' +
    '.expiration-date .selectors .drop-down__select{' +
    '   padding-top: 3px;' +
    '}' +
    '.drop-down__title--select::before {top:5px !important;}' +
    '.drop-down__title::after{top: 2px !important;}';
export const validationSchema = yup.object().shape(Object.assign(Object.assign({}, basicPaymentRule), primaryPhoneRule));
export const b2cValidationSchema = yup.object().shape(Object.assign({}, b2cPaymentRule));
export const getCreditCardFormValuesAddCard = (isDefault) => ({
    isB2B: isB2BUser(),
    cardNickName: '',
    cardBrand: '',
    cardExpiryMonth: '',
    cardExpiryYear: '',
    cardHolderName: '',
    addressLine1: '',
    addressLine2: '',
    zipCode: '',
    cityState: '',
    buyerId: '',
    primaryPhone: {
        number: '',
    },
    isDefaultAddress: false,
    isHDWalletFlow: false,
    isHDCard: false,
    accountNumberXref: '',
    avsCode: '',
    cvvCode: '',
    addressId: '',
    billingAddressID: null,
    recaptcha: '',
    isDefault,
});
const orangePayResponses = {
    NETWORK_ERR: [
        2002, 2003, 2007, 2008, 2014, 2016, 2019, 5030, 5040, 5071, 5072, 5073,
        5074, 5080, 5082, 5085,
    ],
    UI_LOADED: [2004, 2005, 2018],
    VALID_FORM: [3052],
    INVALID_FORM: [3051, 3050, 3040],
    INVALID_PAYMENT: [5010, 5011, 5012, 3021],
    DECLINED: [5020],
    FISERV_FAIL: [2023],
    INFO: [1000, 2006, 2015],
};
export const getOrangePayResponse = ({ reasonCode, }) => {
    const responseKey = Object.keys(orangePayResponses).find((key) => orangePayResponses[key].includes(parseInt(reasonCode, 10)));
    return responseKey || null;
};
export const mapDefaultModal = (cardDetails) => {
    const cardBrand = cardDetails.cardBrand;
    const cardExpiryMonth = cardBrand === 'PROX' ? '' : cardDetails.cardExpiryMonth || '';
    const cardExpiryYear = cardBrand === 'PROX' ? '' : cardDetails.cardExpiryYear || '';
    const cardNumberLast4 = cardDetails.xrefCardNumber.slice(-4);
    return { cardBrand, cardExpiryMonth, cardExpiryYear, cardNumberLast4 };
};
export const OrangePayCardBrandFilterValue = {
    VI: 'VISA',
    MA: 'MA',
    AX: 'AMEX',
    DS: 'DISC',
    HR: 'HDCOM',
    HC: 'HDCON',
    HP: 'PROX',
    HA: 'PROP',
};
export const allowedTypeCardForHDPass = {
    2901: 'Amex',
    2902: 'Discover',
    2903: 'MasterCard',
    2904: 'Visa',
    2905: 'HD Consumer',
    2906: 'HD Commercial',
    2908: 'Home Improver',
    2909: 'Pro Purchase',
    2911: 'Project Loan Mastercard (US)',
};
export const nonAllowedTypeCardForHDPass = {
    2907: 'HD Prox',
};
export const ORANGE_PAY_NO_RESPONSE_TIMEOUT = 20000;
export const NEW_RELIC_PREFIX = 'add-card-pcir';
